import { render, staticRenderFns } from "./DialogPanel.vue?vue&type=template&id=1cade7f9&scoped=true&"
import script from "./DialogPanel.vue?vue&type=script&lang=js&"
export * from "./DialogPanel.vue?vue&type=script&lang=js&"
import style0 from "./DialogPanel.vue?vue&type=style&index=0&id=1cade7f9&scoped=true&lang=css&"
import style1 from "./DialogPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cade7f9",
  null
  
)

export default component.exports